import classnames from 'classnames';
import LoadingDots from 'components/LoadingDots';
import Modal from 'components/Modal';
import ModalBody from 'components/Modal/ModalBody';
import useIsMobile from 'hooks/useIsMobile';
import React from 'react';

const CSS = require('./ActionModal.module.scss');

type ActionModalProps = {
  text: string;
  className?: string;
  onClose?: () => void;
};

const noop = () => {};

function ActionModal({ text, className, onClose }: ActionModalProps) {
  const isMobile = useIsMobile();
  return (
    <Modal show hideClose fullscreen={isMobile} onClose={onClose || noop}>
      <ModalBody className={classnames(CSS.Modal, className)}>
        <h3 className={CSS.Text}>{text}</h3>
        <LoadingDots />
      </ModalBody>
    </Modal>
  );
}

export default ActionModal;
